module.exports = __webpack_public_path__ + "img/1.225d73bf.jpg";